import { render, staticRenderFns } from "./comMagnifierDialog.vue?vue&type=template&id=71cb6a4a&scoped=true&"
import script from "./comMagnifierDialog.vue?vue&type=script&lang=js&"
export * from "./comMagnifierDialog.vue?vue&type=script&lang=js&"
import style0 from "./comMagnifierDialog.vue?vue&type=style&index=0&id=71cb6a4a&lang=scss&scoped=true&"
import style1 from "./comMagnifierDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cb6a4a",
  null
  
)

export default component.exports